export enum ActivityAttendanceStatus {
    Present = 0,
    NotPresentNotExcused = 1,
    NotPresentExcused = 2,
    NotPresentExcusedNoCompensation = 3,
    NotPresentExcusedWithoutFood = 4
}